module.exports = __webpack_public_path__ + "static/media/MEINL_MENU-normal.35b677af.png";